import { render } from "./MyRecommendAdsView.vue?vue&type=template&id=579634ad&scoped=true"
import script from "./MyRecommendAdsView.vue?vue&type=script&lang=js"
export * from "./MyRecommendAdsView.vue?vue&type=script&lang=js"

import "./MyRecommendAdsView.vue?vue&type=style&index=0&id=579634ad&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579634ad"]])

export default __exports__